import { Paper } from '@mantine/core';

import type { SurfaceViewProps } from './Surface.types';

export function SurfaceView({ children, onClick, padding = 'md', h, style }: SurfaceViewProps) {
  return (
    <Paper withBorder radius="md" p={padding} h={h} onClick={onClick} style={{ cursor: onClick ? 'pointer' : undefined, ...style }}>
      {children}
    </Paper>
  );
}
